import React, { Component, lazy, Suspense } from 'react';

import { Overlay, Button, Feedback, Grid, moment } from '@icedesign/base';
import IceContainer from '@icedesign/container';

import PropTypes from 'prop-types';

import { readKeyExperimental, readCollectedLockIds, readKeyInfoEx } from '@/api/HardwareApi';
import { getKey } from '@/api/KeyApi';
import { IoMdFlashOff } from '@/components/Icons/CustomIcons';
import { getKeyTypes } from '@/constants/KeyTypes';
import { formatMessage } from '@/i18n';
import { getKeytypeIcons, getKeytypeText } from '@/pages/Key/functions';
import { isWMSdk, getProfile } from '@/tool/profile';

import ViewBalloon from '../ViewBalloon';

import './KeyConnector.scss';

const FaSkull = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaSkull })));
const FaInfo = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaInfo })));
export default class KeyConnector extends Component {
  static propTypes = {
    title: PropTypes.string,
    desc: PropTypes.string,
    descExtra: PropTypes.node,
    // onConfirm: PropTypes.func,
    // onCancel: PropTypes.func,
    onKeyRead: PropTypes.func,

    // 如果定义此方法，则负责了默认的读取行为
    onKeyConnected: PropTypes.func,
    // 读取完成后是否展示钥匙内信息
    displayKey: PropTypes.bool,

    // 读取钥匙完毕后是否立即关闭窗体，专门为注册人员指纹窗体用的属性
    closeAfterRead: PropTypes.bool,

    // 更换指示动画图
    img: PropTypes.object,
    // TODO: 设计的指纹采集gif与其他尺寸不一，暂时在程序里强制重写一下
    imgStyle: PropTypes.object,
    // 删除应急钥匙操作
    delEmegency: PropTypes.bool,
  };

  static defaultProps = {
    displayKey: false,
    closeAfterRead: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isLoading: false,
      // 指定要读取的keyid(no)
      targetKey: null,
      keyData: null,
      key: null,
      authStatus: [
        // 这里id取-1是因为要当在“全部”状态下要获取所有状态的钥匙，其他的id值是后台接口状态约定;
        {
          key: 0,
          name: formatMessage('key.connector.authority.authstatus.unauthorized'),
          color: '#ffc107',
        },
        {
          key: 1,
          name: formatMessage('key.connector.authority.authstatus.authorized'),
          color: '#8bc34a',
        },
        {
          key: 2,
          name: formatMessage('key.connector.authority.authstatus.expired'),
          color: '#ff5722',
        },
      ],
    };
    this.keytypes = getKeyTypes();
    this.options = null;
  }

  open = (targetKey, options) => {
    this.setState({ visible: true, targetKey });

    this.options = options;
  };

  close = () => {
    this.setState({ visible: false, keyData: null });
  };

  onRequestClose = () => {
    // 平常状态下允许快捷关闭（mask、esc等，操作状态下禁用）
    if (!this.state.isLoading) this.close();
  };

  setLoading = isLoading => {
    this.setState({ isLoading });
  };

  connect = () => {
    const { targetKey } = this.state;
    const { displayKey, onKeyRead, closeAfterRead, delEmegency } = this.props;
    const { lite } = getProfile();
    // this.setState({ isLoading: true });
    this.setLoading(true);
    const postType = delEmegency ? readKeyInfoEx : readKeyExperimental;
    postType()
      .then(
        data => {
          console.log('data', data);
          if (targetKey && targetKey != data.id) {
            // 这里targetKey.keyno和data.id类型是不一样的，一个是字符串一个是数组，不能用全等进行比较（借助类型自动转换特性）。
            Feedback.toast.error(formatMessage('key.connector.unmatch'));
            // 解除挂失过程中，设置closeAfterRead为false，所以在不匹配后无法重置loading状态，这里重置一下
            this.setLoading(false);
          } else if (!displayKey) {
            // TODO: 下方的onKeyRead可能是一个比较耗时的操作，根据外面处理结果来关闭窗体会更好
            if (closeAfterRead) this.close();
            if (onKeyRead)
              // TODO: 这里为什么没有直接返回钥匙物理信息data参数呢
              onKeyRead(data.id, data);
            // } else this.setState({ keyData: data });
            if (this.options && this.options.onKeyConnected) {
              this.options.onKeyConnected(data.id, data);
            }
          } else {
            // 如果是WM并且是采集钥匙，调用读取采集锁号的命令，加入锁号
            // eslint-disable-next-line no-lonely-if
            if (isWMSdk() && data.mode == 19) {
              // 为了防止外层的finally对setLoading进行false赋值导致二次loading状态失败
              // TODO: 利用timeout特性延迟运行一下
              setTimeout(() => {
                this.setLoading(true);
              }, 0);
              // TODO: 这里应该是false吧？？？不然不把读取的锁号给清了？？？
              readCollectedLockIds(false)
                .then(
                  lockids => {
                    this.setState(
                      {
                        keyData: Object.assign(data, {
                          lockid: lockids.length > 0 ? lockids[lockids.length - 1].id : '',
                        }),
                      },
                      () => console.warn('done')
                    );
                  },
                  err => {
                    console.log(err);
                    this.setState({ keyData: data });
                  }
                )
                .finally(() => {
                  this.setLoading(false);
                });
            } else {
              this.setState({ keyData: data });
            }
          }
          // 轻量锁模式获取钥匙信息
          if (lite && displayKey) {
            getKey(data.id).then(existKey => {
              this.setState({ key: existKey });
            });
          }
        },
        err => {
          if (err) Feedback.toast.error(err);
          // 不自己维护窗体关闭状态时，出错后将loading状态重置
          // TODO: 这个地方写的不太好，加载状态没有统一，还需要在采集指纹的外层根据接口返回状态调用setLoading方法
          if (!closeAfterRead) this.setLoading(false);
        }
      )
      .finally(() => {
        // this.setState({ isLoading: false });
        if (closeAfterRead) this.setLoading(false);
      });
  };

  getDaysDifference = date2 => {
    const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
    const firstDate = new Date();
    const secondDate = new Date(date2);

    const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
    return diffDays;
  };

  render() {
    const {
      title = formatMessage('key.connector.please.connect'),
      desc = formatMessage('key.connector.please.connect'),
      descExtra,
      onKeyConnected,
      img,
      imgStyle,
    } = this.props;
    const { visible, isLoading, keyData, targetKey, key, authStatus } = this.state;
    const { lite } = getProfile();
    const daysDiff = key?.authstatus ? this.getDaysDifference(key?.expiretime) : 0;
    return (
      <div>
        {/* TODO: Overlay的背景可以更深一点 */}
        <Overlay
          visible={visible}
          hasMask
          disableScroll
          align="cc cc"
          // 不设置高度不居中???
          style={styles.overlayContainer}
          onRequestClose={this.onRequestClose}
          wrapperClassName="overlayWrapper"
          // shouldUpdatePosition={true} //防止出现个别情况下不居中的问题，不然就需要使内容高度固定，像LockConnector那样;
        >
          {!keyData ? (
            <IceContainer title={this.options?.title || title} style={styles.overlayContent}>
              {/* TODO: 这里首次加载图片时会有延迟，可以先填充一个骨架 */}
              {/* <img src={require('@/images/key-con-bg.jpg')} style={{ width: 320, height: 'auto' }} /> */}
              <img
                src={
                  img ||
                  (isWMSdk()
                    ? require('@/images/key-connect-wm.gif')
                    : require('@/images/key-connect-hm.gif'))
                }
                style={imgStyle || { width: 320, height: 'auto' }}
              />
              <div style={styles.desc}>
                {/* TODO: 当连接指定钥匙的时候需不需要进行名称提示？但是目前传递过来的只有keyno没有keyname */}
                {/* <span >{desc}</span> */}
                <span dangerouslySetInnerHTML={{ __html: this.options?.desc || desc }} />
                {!targetKey && descExtra}
              </div>
              <div style={styles.buttons}>
                <Button.Group>
                  <Button onClick={this.close} disabled={isLoading}>
                    {formatMessage('key.connector.cancel')}
                  </Button>
                  <Button
                    type="primary"
                    onClick={onKeyConnected || this.connect}
                    loading={isLoading}
                  >
                    {formatMessage('key.connector.confirm')}
                  </Button>
                </Button.Group>
              </div>
            </IceContainer>
          ) : lite ? (
            <IceContainer title={title} style={{ ...styles.overlayContent, paddingBottom: 55 }}>
              <h5 style={styles.infoGroupTitle}>{formatMessage('key.connector.key.info')}</h5>
              <KeyInfoItem title={formatMessage('key.connector.key.id')} value={keyData.id} />
              <KeyInfoItem title={formatMessage('key.edit.basic.name')} value={key?.keyname} />
              <KeyInfoItem title={formatMessage('key.column.battery')} value={keyData.power} />
              <KeyInfoItem
                title={formatMessage('table.column.deptname')}
                value={key?.dept?.deptname}
              />
              <KeyInfoItem
                title={formatMessage('key.connector.key.type')}
                value={(() => {
                  const Icons = getKeytypeIcons(keyData.mode === 1 ? 12 : keyData.keytype);
                  // switch (keyData.keytype) {
                  //     //TODO: 类型后期封装为常量
                  //     case 0: Icon = FaKey; title = formatMessage('key.type.normal'); break;
                  //     case 1: Icon = FaBluetooth; title = formatMessage('key.type.ble'); break;
                  //     case 2: Icon = IoMdFingerPrint; title = formatMessage('key.type.fingerprint'); break;
                  // }
                  return (
                    <ViewBalloon
                      trigger={
                        <Grid.Row>{Icons.map(icon => icon)}</Grid.Row>
                        // keyData.keytype < 3 ?

                        // <Icon size={20} />
                        // :
                        // <Grid.Row><FaBluetooth size={20} /><IoMdFingerPrint size={20} /></Grid.Row>
                      }
                      content={
                        getKeytypeText(keyData.mode === 1 ? 12 : keyData.keytype)
                        // keyData.keytype < 3 ? title : `${formatMessage('key.type.ble')}; ${formatMessage('key.type.fingerprint')}`
                      }
                    />
                  );
                })()}
              />
              <KeyInfoItem
                title={formatMessage('key.connector.key.mode')}
                // value={(isWMSdk() ? `${KeyTypes[keyData.mode]} ${keyData.mode === 10 && !keyData.recordCount ? ' [' + keyData.recordCount + formatMessage('table.page.record.count') + ']' : '' }` : KeyTypes[keyData.type]) || formatMessage('key.connector.key.mode.unknown')}
                value={
                  <>
                    {(isWMSdk()
                      ? `${this.keytypes[keyData.mode === 1 ? 9 : keyData.mode]} ${
                          keyData.mode === 10 && keyData.recordCount
                            ? ` (${keyData.recordCount} ${formatMessage(
                                'table.page.record.count'
                              )})`
                            : ``
                        }`
                      : this.keytypes[keyData.type]) ||
                      formatMessage('key.connector.key.mode.unknown')}
                    {keyData.offline && <IoMdFlashOff size={16} style={{ marginLeft: 5 }} />}
                    {keyData.ver >= 772 && keyData.taskEnabled && (
                      <Suspense fallback={null}>
                        <FaInfo size={16} style={{ marginLeft: 5 }} />
                      </Suspense>
                    )}
                  </>
                }
                // TODO: 记录数量，暂未兼容B系列和不支持recordCount属性的C（到底什么钥匙支持recordCount，什么钥匙需要发命令读一下）？
              />
              {/* <KeyInfoItem title={formatMessage('key.connector.key.type')} value={KeyTypes[keyData.type] || formatMessage('key.connector.key.type.unknown')} /> */}

              <KeyInfoItem
                title={formatMessage('key.connector.key.version')}
                value={
                  <span>
                    {keyData.version || keyData.ver} {keyData.multitask && 'M'}{' '}
                  </span>
                }
              />
              {/* TODO: 这个判断方法有风险吗？ */}
              {keyData.blacklistflag >= 0 && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.blacklist')}
                  value={
                    keyData.blacklistflag ? (
                      <Suspense fallback={null}>
                        <FaSkull />
                      </Suspense>
                    ) : (
                      '-'
                    )
                  }
                />
              )}

              {/* TODO: 时间格式化？ */}
              <KeyInfoItem title={formatMessage('key.connector.key.time')} value={keyData.time} />
              <h5 style={styles.infoGroupTitle}>{formatMessage('key.connector.authority.info')}</h5>
              <KeyInfoItem
                title={formatMessage('key.connector.authority.authstatus')}
                value={authStatus[key?.authstatus || 0].name}
              />
              {key?.authstatus ? (
                <>
                  <KeyInfoItem
                    title={formatMessage('key.connector.authority.authtime')}
                    value={key?.authtime}
                  />
                  <KeyInfoItem
                    title={formatMessage('key.connector.authority.expiretime')}
                    value={key?.expiretime}
                    authstatus={daysDiff <= 3 ? 2 : key?.authstatus}
                  />
                </>
              ) : (
                ''
              )}
              <div style={styles.buttons}>
                <Button.Group>
                  <Button
                    onClick={() => {
                      this.setState({ keyData: null });
                    }}
                    disabled={isLoading}
                  >
                    &nbsp;{formatMessage('key.connector.back')}&nbsp;
                  </Button>
                  <Button type="primary" onClick={this.close} loading={isLoading}>
                    &nbsp;{formatMessage('key.connector.close')}&nbsp;
                  </Button>
                </Button.Group>
              </div>
            </IceContainer>
          ) : (
            <IceContainer title={title} style={{ ...styles.overlayContent, paddingBottom: 55 }}>
              <h5 style={styles.infoGroupTitle}>{formatMessage('key.connector.key.info')}</h5>

              <KeyInfoItem title={formatMessage('key.connector.key.id')} value={keyData.id} />

              {/* HM Only */}
              {keyData.keyfactorynumber && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.factory.no')}
                  value={keyData.keyfactorynumber}
                />
              )}

              <KeyInfoItem
                title={formatMessage('key.connector.key.type')}
                value={(() => {
                  const Icons = getKeytypeIcons(keyData.mode === 1 ? 12 : keyData.keytype);
                  // switch (keyData.keytype) {
                  //     //TODO: 类型后期封装为常量
                  //     case 0: Icon = FaKey; title = formatMessage('key.type.normal'); break;
                  //     case 1: Icon = FaBluetooth; title = formatMessage('key.type.ble'); break;
                  //     case 2: Icon = IoMdFingerPrint; title = formatMessage('key.type.fingerprint'); break;
                  // }
                  return (
                    <ViewBalloon
                      trigger={
                        <Grid.Row>{Icons.map(icon => icon)}</Grid.Row>
                        // keyData.keytype < 3 ?

                        // <Icon size={20} />
                        // :
                        // <Grid.Row><FaBluetooth size={20} /><IoMdFingerPrint size={20} /></Grid.Row>
                      }
                      content={
                        getKeytypeText(keyData.mode === 1 ? 12 : keyData.keytype)
                        // keyData.keytype < 3 ? title : `${formatMessage('key.type.ble')}; ${formatMessage('key.type.fingerprint')}`
                      }
                    />
                  );
                })()}
              />

              {/* 钥匙模式，hm使用type字段，wm使用mode */}
              <KeyInfoItem
                title={formatMessage('key.connector.key.mode')}
                // value={(isWMSdk() ? `${KeyTypes[keyData.mode]} ${keyData.mode === 10 && !keyData.recordCount ? ' [' + keyData.recordCount + formatMessage('table.page.record.count') + ']' : '' }` : KeyTypes[keyData.type]) || formatMessage('key.connector.key.mode.unknown')}
                value={
                  <>
                    {(isWMSdk()
                      ? `${this.keytypes[keyData.mode === 1 ? 9 : keyData.mode]} ${
                          keyData.mode === 10 && keyData.recordCount
                            ? ` (${keyData.recordCount} ${formatMessage(
                                'table.page.record.count'
                              )})`
                            : ``
                        }`
                      : this.keytypes[keyData.type]) ||
                      formatMessage('key.connector.key.mode.unknown')}
                    {keyData.offline && <IoMdFlashOff size={16} style={{ marginLeft: 5 }} />}
                    {keyData.ver >= 772 && keyData.taskEnabled === true && (
                      <Suspense fallback={null}>
                        <FaInfo size={16} style={{ marginLeft: 5 }} />
                      </Suspense>
                    )}
                  </>
                }
                // TODO: 记录数量，暂未兼容B系列和不支持recordCount属性的C（到底什么钥匙支持recordCount，什么钥匙需要发命令读一下）？
              />
              {/* <KeyInfoItem title={formatMessage('key.connector.key.type')} value={KeyTypes[keyData.type] || formatMessage('key.connector.key.type.unknown')} /> */}

              <KeyInfoItem
                title={formatMessage('key.connector.key.version')}
                value={
                  <span>
                    {keyData.version || keyData.ver} {keyData.multitask && 'M'}{' '}
                  </span>
                }
              />
              {/* TODO: 任务ID，只有在单任务下 */}
              {!keyData.multitask &&
                keyData.ver >= 772 &&
                keyData.taskEnabled &&
                keyData.mode === 10 && (
                  <KeyInfoItem
                    title={formatMessage('key.connector.key.taskid')}
                    value={keyData.taskId && keyData.taskId !== -1 ? keyData.taskId : '-'}
                  />
                )}
              {/* TODO: 这个判断方法有风险吗？ */}
              {keyData.blacklistflag >= 0 && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.blacklist')}
                  value={
                    keyData.blacklistflag ? (
                      <Suspense fallback={null}>
                        <FaSkull />
                      </Suspense>
                    ) : (
                      '-'
                    )
                  }
                />
              )}

              {/* TODO: 时间格式化？ */}
              <KeyInfoItem title={formatMessage('key.connector.key.time')} value={keyData.time} />

              {/* HM Only, WM 各种钥匙模式暂时没有过期概念 */}
              {/* TODO: 适配readKeyExperimental接口？ */}
              {/* HM中除了钥匙的time，其他时间如activationtime、expirytime、createtime的设置及读取返回值均只精确到分钟； */}
              {keyData.activationtime && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.time.effective')}
                  value={moment(keyData.activationtime, 'YYMMDDHHmm').format('YYYY-MM-DD HH:mm')}
                />
              )}
              {/* 这里实际显示的是领出时设置的结束时间+1天，因为要考虑到0点的问题 */}
              {keyData.expirytime && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.time.invalid')}
                  value={
                    isWMSdk()
                      ? keyData.expirytime
                      : moment(keyData.expirytime, 'YYMMDDHHmm').format('YYYY-MM-DD HH:mm')
                  }
                />
              )}
              {keyData.createtime && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.time.create')}
                  value={moment(keyData.createtime, 'YYMMDDHHmm').format('YYYY-MM-DD HH:mm')}
                />
              )}

              {/* WM Only */}
              {/* 2023-05-30针对应急钥匙加入生效过期时间 validity from to  */}
              {/* TODO: 其他类型钥匙生效到期时间显示？ */}
              {keyData.validity?.from && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.time.effective')}
                  value={moment(keyData.validity.from).format('YYYY-MM-DD HH:mm')}
                />
              )}
              {keyData.validity?.to && (
                <KeyInfoItem
                  title={formatMessage('key.connector.key.time.invalid')}
                  value={moment(keyData.validity.to).format('YYYY-MM-DD HH:mm')}
                />
              )}

              {/* WM Only */}
              {isWMSdk() && <KeyInfoItem title="Overseas" value={keyData.sign} />}
              {(keyData.lockid || keyData.newlockid || keyData.lockfactorynumber) && (
                <div>
                  <h5 style={styles.infoGroupTitle}>{formatMessage('key.connector.lock.info')}</h5>
                  {keyData.lockid && (
                    <KeyInfoItem
                      title={formatMessage('key.connector.lock.id')}
                      value={keyData.lockid}
                    />
                  )}
                  {keyData.newlockid && (
                    <KeyInfoItem
                      title={formatMessage('key.connector.lock.intent.id')}
                      value={keyData.newlockid}
                    />
                  )}
                  {keyData.lockfactorynumber && (
                    <KeyInfoItem
                      title={formatMessage('key.connector.lock.factory.no')}
                      value={keyData.lockfactorynumber}
                    />
                  )}
                </div>
              )}
              <div style={styles.buttons}>
                <Button.Group>
                  <Button
                    onClick={() => {
                      this.setState({ keyData: null });
                    }}
                    disabled={isLoading}
                  >
                    &nbsp;{formatMessage('key.connector.back')}&nbsp;
                  </Button>
                  <Button type="primary" onClick={this.close} loading={isLoading}>
                    &nbsp;{formatMessage('key.connector.close')}&nbsp;
                  </Button>
                </Button.Group>
              </div>
            </IceContainer>
          )}
        </Overlay>
      </div>
    );
  }
}

function KeyInfoItem(props) {
  const { title, value, authstatus } = props;
  return (
    <Grid.Row style={styles.itemContainer}>
      <span style={styles.itemLabel}>{title}</span>
      <span style={authstatus === 2 ? styles.itemRedValue : styles.itemValue}>{value}</span>
    </Grid.Row>
  );
}

const styles = {
  overlayContainer: {
    width: 380,
  },
  overlayContent: {
    minHeight: 400,
    textAlign: 'center',
  },
  desc: {
    marginTop: 20,
  },
  buttons: {
    textAlign: 'center',
    position: 'absolute',
    // marginTop: 20,
    // marginBottom: 5,
    bottom: 20,
    width: 320,
  },
  infoGroupTitle: {
    width: 320,
    margin: '20px 0',
    paddingLeft: '10px',
    borderLeft: '5px solid #3080fe',
    textAlign: 'left',
  },
  itemContainer: {
    marginLeft: '16px',
    marginBottom: '5px',
    textAlign: 'left',
  },
  itemLabel: {
    minWidth: '100px',
    color: '#999',
  },
  itemValue: {
    color: '#333',
    display: 'flex',
    alignItems: 'center',
  },
  itemRedValue: {
    color: '#ff5722',
    display: 'flex',
    alignItems: 'center',
  },
};
